
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
    persistReducer,
    persistStore,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
    createTransform,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './auth/authReducer';
import productReducer from './products/productReducer';
import cartReducer from './cart/cartReducer';
import businessReducer from './business/businessReducer';
import orderReducer from './orders/orderReducer';
import paymentReducer from './payments/paymentReducer';
import googleBusinessReducer from './googleBusiness/googleBusinessReducer';

// Custom transform for modifying state before persisting
const authTransform = createTransform(
    (inboundState, key) => {
        if (key === 'auth' && inboundState) {
            return {
                ...(inboundState as object),
                user: (inboundState as any)?.user || null,
            };
        }
        return inboundState;
    },
    (outboundState) => {
        return outboundState;
    }
);

// Persist configuration
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth'], // Add reducers to persist here
    blacklist: [], // Add reducers to ignore persistence here
    transforms: [authTransform],
};

// Combine reducers (currently empty, add reducers as needed)
const rootReducer = combineReducers({
    auth: authReducer,
    products: productReducer,
    categories: productReducer,
    cart: cartReducer,
    business: businessReducer,
    orders: orderReducer,
    payment: paymentReducer,
    googleBusiness: googleBusinessReducer,
});

// Apply persist reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create and configure the Redux store
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

// Persistor for Redux Persist
export const persistor = persistStore(store);

// Types for TypeScript (optional)
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
